document.addEventListener("DOMContentLoaded", function () {
  const apptsBtns = document.querySelectorAll(".appts-btn");
  const popupWrapper = document.querySelector(".appts-popup-wrapper");
  const popup = document.querySelector(".appts-popup");
  const popupClose = document.querySelector(".popup-close");

  if (popupWrapper && popup && popupClose) {
    apptsBtns.forEach(btn => {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        popupWrapper.style.opacity = "1";
        popupWrapper.style.visibility = "visible";
        popup.style.transform = "translateY(0px)";
        popup.style.opacity = "1";
        popup.style.visibility = "visible";
      });
    });

    popupClose.addEventListener("click", function () {
      popupWrapper.style.opacity = "0";
      popupWrapper.style.visibility = "hidden";
      popup.style.transform = "translateY(200px)";
      popup.style.opacity = "0";
      popup.style.visibility = "hidden";
    });
  }
});
